import { gql } from '@apollo/client';
import { AreaType } from 'graphql/queries/getAreasByWarehouseId';

export const SAVE_AREAS_WITH_ZIPCODE_SYNC = gql`
    mutation SaveAreasWithZipcodeSync($areas: [AreaTypeInput!]!) {
        saveAreasWithZipcodeSync(areas: $areas) {
            id
            name
            sortingCode
            warehouseId
            dspId
            zipcodeList
        }
    }
`;

export interface SaveAreasWithZipcodeSyncResponse {
    saveAreasWithZipcodeSync: AreaType[];
}

export interface SaveAreasWithZipcodeSyncVariables {
    areas: AreaTypeInput[];
}

export interface AreaTypeInput {
    id?: string;
    name?: string;
    sortingCode?: string;
    warehouseId: string;
    dspId?: string;
    zipcodeList: string[];
}

// ==================== 灰度仓：路线邮编编辑新流程 ====================

/** 确认生效：一次性落库 + 锁定该仓「更新运单数据中」+ 触发下游刷数 */
export const CONFIRM_ROUTE_ZIPCODE_CHANGE = gql`
    mutation ConfirmRouteZipcodeChange($warehouseId: Long!, $areas: [AreaTypeInput!]!, $deletedAreaIds: [Long!]) {
        confirmRouteZipcodeChange(warehouseId: $warehouseId, areas: $areas, deletedAreaIds: $deletedAreaIds) {
            routeCount
            zipcodeCount
        }
    }
`;

export interface RouteChangeConfirmResult {
    routeCount: number;
    zipcodeCount: number;
}

export interface ConfirmRouteZipcodeChangeResponse {
    confirmRouteZipcodeChange: RouteChangeConfirmResult;
}

export interface ConfirmRouteZipcodeChangeVariables {
    warehouseId: number;
    areas: AreaTypeInput[];
    deletedAreaIds?: number[];
}

/** 导入校验预览：6 项校验通过返回覆盖后的暂存配置（不落库） */
export const VALIDATE_AND_PREVIEW_ROUTE_IMPORT = gql`
    mutation ValidateAndPreviewRouteImport($warehouseId: Long!, $rows: [RouteImportRowInput!]!) {
        validateAndPreviewRouteImport(warehouseId: $warehouseId, rows: $rows) {
            areas {
                id
                name
                sortingCode
                warehouseId
                dspId
                zipcodeList
            }
            deletedAreaIds
        }
    }
`;

export interface RouteImportRowInput {
    id?: string;
    name?: string;
    zipcodeList: string[];
    sortingCode?: string;
    dspName?: string;
    action?: string;
}

export interface RouteImportPreview {
    areas: AreaType[];
    deletedAreaIds: number[];
}

export interface ValidateAndPreviewRouteImportResponse {
    validateAndPreviewRouteImport: RouteImportPreview;
}

export interface ValidateAndPreviewRouteImportVariables {
    warehouseId: number;
    rows: RouteImportRowInput[];
} 